import React from 'react';
import HeroBanner from '../components/tw1/HeroBanner';
import { CreditCard, ExternalLink, AlertTriangle, Info, Clock, Keyboard } from 'lucide-react';
import { Button } from '../components/ui/button';
import { EXACT_LOGO } from '../lib/logos';

const C = '#059669';

export default function BetalingenPage() {
  return (
    <div className="tw1-fade-in" data-testid="betalingen-page">
      <HeroBanner title="Betalingen Exact" subtitle="Handleiding leveranciersbetalingen via Exact Online" variant="emerald" icon={CreditCard} logos={[{ src: EXACT_LOGO, alt: 'Exact' }]} />

      <div className="space-y-5">
        {/* Stappen */}
        <div className="tw1-card p-5" data-testid="betalingen-steps">
          <h2 className="text-sm font-bold text-[#0b1220] mb-4">Stappen</h2>
          <div className="space-y-3">
            {[
              { n: 1, text: 'Open Exact Online' },
              { n: 2, text: 'Open de juiste entiteit (linksboven wisselen)' },
              { n: 3, text: 'Ga naar Financieel → Bank en Kas → Betalingen' },
              { n: 4, text: 'Selecteer openstaande betalingen' },
            ].map(s => (
              <div key={s.n} className="flex items-start gap-3">
                <div className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 text-xs font-bold text-white" style={{ background: C }}>{s.n}</div>
                <p className="text-sm text-[#3a4553] pt-1">{s.text}</p>
              </div>
            ))}

            {/* Stap 5 met waarschuwing */}
            <div className="flex items-start gap-3">
              <div className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 text-xs font-bold text-white" style={{ background: C }}>5</div>
              <p className="text-sm text-[#3a4553] pt-1">Eén voor één verrichten</p>
            </div>
            <div className="flex items-start gap-3 bg-red-50 border border-red-200 rounded-xl p-3 ml-10" data-testid="betalingen-warning">
              <AlertTriangle className="w-5 h-5 text-[#c0392b] shrink-0 mt-0.5" />
              <p className="text-sm font-semibold text-[#c0392b]">NOOIT verzamelbetaling gebruiken!</p>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 text-xs font-bold text-white" style={{ background: C }}>6</div>
              <div className="pt-1">
                <p className="text-sm text-[#3a4553]">Sneltoets gebruiken:</p>
                <div className="flex items-center gap-2 mt-1.5">
                  <Keyboard className="w-4 h-4 text-[#526071]" />
                  <code className="text-xs bg-gray-100 px-2 py-1 rounded font-mono">Alt+4</code>
                  <span className="text-xs text-[#526071]">→</span>
                  <code className="text-xs bg-gray-100 px-2 py-1 rounded font-mono">Alt+V</code>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Schema */}
        <div className="tw1-card p-5" data-testid="betalingen-schema">
          <div className="flex items-center gap-2 mb-3">
            <Clock className="w-4 h-4" style={{ color: C }} />
            <h2 className="text-sm font-bold text-[#0b1220]">Schema</h2>
          </div>
          <div className="space-y-2">
            <div className="rounded-lg p-3 text-sm" style={{ background: `${C}08` }}>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full" style={{ background: C }} />
                <span className="text-[#3a4553]">Frequentie: <strong>minimaal 1× per week, elke vrijdag</strong></span>
              </div>
            </div>
            <div className="rounded-lg p-3 text-sm" style={{ background: `${C}08` }}>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full" style={{ background: C }} />
                <span className="text-[#3a4553]"><strong>Per entiteit apart</strong> uitvoeren</span>
              </div>
            </div>
          </div>
        </div>

        {/* Snelkoppelingen */}
        <div className="tw1-card p-5" data-testid="betalingen-links">
          <h2 className="text-sm font-bold text-[#0b1220] mb-3">Snelkoppelingen</h2>
          <a href="https://start.exactonline.nl" target="_blank" rel="noopener noreferrer">
            <Button className="text-white text-sm" style={{ background: C }} data-testid="betalingen-exact-link">
              <ExternalLink className="w-4 h-4 mr-2" /> Open Exact Online
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}
